import React, { useEffect } from 'react';
import { Box, Button, Typography, Container } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import UserProfile from '../Profile/Profile'; 
import UserDisplay from './UserDisplay'; 

// Add TypeScript declaration for adsbygoogle
declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

// AdSense component
const AdUnit = () => {
  useEffect(() => {
    // Initialize ads when component mounts
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <Box sx={{ width: '100%', mt: 2, overflow: 'hidden' }}>
      <ins className="adsbygoogle"
           style={{ display: 'block' }}
           data-ad-client="ca-pub-4720780210438748"
           data-ad-slot="YOUR_AD_SLOT_ID"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
    </Box>
  );
};

const Sidebar = () => {
  return (
    <>
      <div>
        <Box sx={{ position: 'sticky', top: '71px', }}>
          <Container 
            disableGutters 
            maxWidth='sm'
            className='sidebar'
            sx={{
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'column',
              width: '300px',
              minWidth: '300px',
              justifyContent: 'center',
              alignItems: 'center',
              right: 0,
              backgroundColor: '#f5f5f5',
              overflow: 'auto',
            }}
          >
            <UserDisplay />
            
            {/* AdSense Ad Unit */}
            <AdUnit />
          </Container>
        </Box>
      </div>
    </>
  );
};

export default Sidebar;